import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin12Mobile from "../../assets/images/modems/processed/transponder_mobile_spin12.png"

const Spin12_MOBILE = () => {
  const { t, i18n } = useTranslation();
  
  return (
     <Link to="/acoustic_modems#spin12_mobile_spec" className="card-link-wrapper">
        <div className="card-beacon">
            <img src={ImageSpin12Mobile} alt={t('products.types.communcation_12_BEACON_MOBILE.title')} className="card-image" />
            <div className="card-content">
              <h3 className="card-title">{t('products.types.communcation_12_BEACON_MOBILE.title')}</h3>
              <p className="card-description">
                <ul class="features-list">
                  <li>{t('products.types.communcation_12_BEACON_MOBILE.li_1')}</li>
                  <li>{t('products.types.communcation_12_BEACON_MOBILE.li_2')}</li>
                  <li>{t('products.types.communcation_12_BEACON_MOBILE.li_3')}</li>
                  <li>{t('products.types.communcation_12_BEACON_MOBILE.li_4')}</li>
                </ul>
              </p>
            </div>
          </div>
        </Link>
  );
};
export default Spin12_MOBILE;